import { useTranslation } from 'react-i18next';
import type { TaskDto } from '@monorepo/shared';
import type { TaskScopeTab } from '../../services/tasks.service';
import { TaskRow } from './TaskRow';

interface TasksTableProps {
  tasks: TaskDto[];
  scope: TaskScopeTab;
  pendingReminderTaskId: string | null;
  onAction: (task: TaskDto) => void;
  onViewDocument: (task: TaskDto) => void;
  onSendReminder: (task: TaskDto) => void;
}

const headerCellClassName = 'px-4 py-2.5 text-left text-sm font-medium text-[#5c6670]';

export const TasksTable = ({
  tasks,
  scope,
  pendingReminderTaskId,
  onAction,
  onViewDocument,
  onSendReminder,
}: TasksTableProps) => {
  const { t } = useTranslation();
  const columnCount = scope === 'all' ? 5 : 4;

  return (
    <table className="block w-full lg:table lg:border-separate lg:border-spacing-y-3">
      <thead className="hidden lg:table-header-group">
        <tr>
          <th className={headerCellClassName}>{t('tasks.table.columns.name')}</th>
          {scope === 'all' && (
            <th className={headerCellClassName}>{t('tasks.table.columns.user')}</th>
          )}
          <th className={headerCellClassName}>{t('tasks.table.columns.status')}</th>
          <th className={headerCellClassName}>{t('tasks.table.columns.due_date')}</th>
          <th className={`${headerCellClassName} text-right`}>{t('tasks.table.columns.action')}</th>
        </tr>
      </thead>
      <tbody className="flex flex-col gap-3 lg:table-row-group">
        {tasks.length === 0 ? (
          <tr className="block lg:table-row">
            <td
              colSpan={columnCount}
              className="block px-4 py-10 text-center text-gray-500 lg:table-cell"
            >
              {t('tasks.table.empty')}
            </td>
          </tr>
        ) : (
          tasks.map((task) => (
            <TaskRow
              key={task.id}
              task={task}
              scope={scope}
              pendingReminderTaskId={pendingReminderTaskId}
              onAction={onAction}
              onViewDocument={onViewDocument}
              onSendReminder={onSendReminder}
            />
          ))
        )}
      </tbody>
    </table>
  );
};
